import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { voteStore } from '../utils/voteStore';

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const user = voteStore.getUser();
    if (!user || !user.fullName || !user.email) {
      // No user info found, redirect to home
      navigate('/', { replace: true });
    }

  }, [navigate]);

  // Check if user exists before rendering children
  const user = voteStore.getUser();
  if (!user || !user.fullName || !user.email) {
    return null; // Don't render anything while redirecting
  }

  return children;
};

export default ProtectedRoute;
